import { Image, Typography } from "antd";
import Logo from "../../assets/images/auth-logo.png";

const { Title } = Typography;

const AuthCardLayout = ({ title, subtitle, children, showLogo = true }) => (
  <div className="forgot-password-container">
    {showLogo && (
      <div className="forgot-logo-container">
        <Image preview={false} src={Logo} alt="Logo" />
      </div>
    )}
    <div className="forgot-password-card-container">
      {title && <Title level={2}>{title}</Title>}
      {subtitle}
      {children}
    </div>
  </div>
);

export default AuthCardLayout;
